import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CreateArtForm } from "web_myplann/Portfolio/Pages/ArtCreate/CreateArtForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

export const AddArtPage = () => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout title={t(Resources.Portfolio.AddArt.title)}>
			<CreateArtForm />
		</PortfolioAddLayout>
	);
};
